import React, { CSSProperties } from "react";
import SpeakerItem from "../speaker/components/SpeakerItem";

interface FaceProfilePreviewViewProps {
  name?: string;
  isProcessing: boolean;
  ghost?: boolean;
  path?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  selected?: boolean;
  fullSize?: boolean;
  className?: string;
}

const FaceProfilePreviewView: React.FC<FaceProfilePreviewViewProps> = ({
  name,
  ghost,
  path,
  style,
  onClick,
  fullSize,
  className,
}) => {
  const defaultOutContainerStyle = {
    flex: "0 1 128px",
    ...style,
  };
  const fullSizeOutContainerStyle: CSSProperties = {
    ...defaultOutContainerStyle,
    overflow: "unset",
    border: "none",
  };

  const outerContainerStyle = fullSize
    ? fullSizeOutContainerStyle
    : defaultOutContainerStyle;
  const defaultImageContainerStyle: CSSProperties = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "inherit",
  };
  const fullSizeImageContainerStyle: CSSProperties = {
    backgroundPosition: "bottom",
    backgroundSize: "contain",
    width: "100%",
    bottom: 10,
    height: "40%", // The backend ratio of the presenter to video
    objectFit: "cover",
    backgroundRepeat: "no-repeat",
    backgroundOrigin: "border-box",
    borderRadius: "unset",
  };
  const imageContainerStyle = fullSize
    ? fullSizeImageContainerStyle
    : defaultImageContainerStyle;
  return (
    <SpeakerItem
      ghost={ghost}
      className={className}
      title={name}
      align="center"
      justify="center"
      aria-label={name}
      style={outerContainerStyle}
      onClick={onClick}
    >
      <img
        loading="lazy"
        style={imageContainerStyle}
        src={path ?? ""}
        alt={name}
      />
    </SpeakerItem>
  );
};

export default FaceProfilePreviewView;
